import { useState, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import JWTModule from 'jsonwebtoken';
// polyfilled abort controller so gatsby runtime doesn't shit the bed
// also IE
import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only';

/* To know if the component has hydrated on the browser vs rendered on the server */
export function useMounted() {
  const [isMounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  return isMounted;
}

export function useData(url) {
  // TODO: tidy this up to deal with multiple requests and dynamic references

  // we use AbortController to clean up pending requests on unmount
  // so we don't have unresolved promises leaking everywhere.
  const [data, setData] = useState(null);
  const [isLoading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const abortController = new AbortController();
    fetch(url, {
      signal: abortController.signal,
      credentials: 'include',
    })
      .then(res => res.json())
      .then(data => {
        setData(data);
        setLoading(false);
      })
      .catch(err => {
        // if the promise isn't cancelled due to an abort,
        // assume its a real error and set it in state.
        setLoading(false);
        if (!abortController.signal.aborted) {
          setError(err);
        }
      });
    // call abortController.abort() on unmount
    return () => abortController.abort();
  }, [url]);
  return { data, error, isLoading };
}

function hasExpired(token) {
  if (!token) {
    return true;
  }
  const decoded = JWTModule.decode(token, { complete: true });
  const current_time = new Date().getTime() / 1000;
  if (current_time > decoded.payload.exp) {
    return true;
  }
  return false;
}

export function useProfile() {
  const [cookies] = useCookies();
  const token = cookies[process.env.GATSBY_CONSTELLATION_COOKIE];
  if (!token || hasExpired(token)) {
    return null;
  }
  return JWTModule.decode(token, { complete: true }).payload;
}

export function useSession() {
  const isMounted = useMounted();
  const [cookies] = useCookies();

  const token = cookies[process.env.GATSBY_CONSTELLATION_COOKIE];
  if (isMounted && token && !hasExpired(token)) {
    return true;
  }
  return false;
}

export function useLogout() {
  const [cookies, setCookie, removeCookie] = useCookies();
  const logout = () => {
    if (cookies[process.env.GATSBY_CONSTELLATION_COOKIE]) {
      removeCookie(process.env.GATSBY_CONSTELLATION_COOKIE, {
        path: '/',
        domain: process.env.GATSBY_CONSTELLATION_COOKIE_DOMAIN,
      });
    }
  };
  return { logout };
}
